import React, { useState } from "react";
import styles from "./VisualPattern.module.css";
import { updateScore } from "../../utils/storage";

const VisualPattern = ({ goHome }) => {
  const [pattern, setPattern] = useState([]);
  const [userInput, setUserInput] = useState([]);
  const [show, setShow] = useState(false);
  const [checking, setChecking] = useState(false);

  const [score, setScore] = useState(0);
  const [level, setLevel] = useState(1);
  const [gameOver, setGameOver] = useState(false);
  const [feedback, setFeedback] = useState("");

  // 🔥 GRID SEMPRE QUADRADO (cresce com nível)
  const getGridDimension = () => {
    if (level < 5) return 3;
    if (level < 10) return 4;
    if (level < 20) return 5;
    if (level < 35) return 6;
    if (level < 50) return 7;
    return 8;
  };

  const dimension = getGridDimension();
  const gridSize = dimension * dimension;

  // 🔥 DIFICULDADE AJUSTADA
  const getPatternSize = () => {
    const base = 2;
    const growth = Math.floor(level * 1.6);
    return Math.min(gridSize - 2, base + growth);
  };

  const getShowTime = () => {
    return Math.max(400, 1800 - level * 90);
  };

  const generatePattern = () => {
    const numbers = [];

    while (numbers.length < getPatternSize()) {
      const n = Math.floor(Math.random() * gridSize);
      if (!numbers.includes(n)) numbers.push(n);
    }

    return numbers;
  };

  const start = () => {
    const newPattern = generatePattern();

    setPattern(newPattern);
    setUserInput([]);
    setShow(true);
    setChecking(false);
    setFeedback("");

    setTimeout(() => {
      setShow(false);
    }, getShowTime());
  };

  const toggleCell = (index) => {
    if (show || checking) return;

    if (userInput.includes(index)) {
      setUserInput(userInput.filter(i => i !== index));
    } else {
      setUserInput([...userInput, index]);
    }
  };

  const normalize = (arr) => [...arr].sort().join("");

  const check = () => {
    setChecking(true);

    const correct = normalize(userInput) === normalize(pattern);

    if (correct) {
      const newScore = score + level * 7;

      setScore(newScore);
      setLevel(level + 1);

      setFeedback("✔ Boa! Próximo nível...");

      updateScore("visual", newScore);

      setTimeout(() => {
        start();
      }, 500);
    } else {
      setFeedback("❌ Errou!");
      setGameOver(true);
    }
  };

  const restart = () => {
    setPattern([]);
    setUserInput([]);
    setShow(false);
    setChecking(false);
    setScore(0);
    setLevel(1);
    setGameOver(false);
    setFeedback("");
  };

  if (gameOver) {
    return (
      <div className={styles.container}>
        <h3>👁️ Memória Visual</h3>

        <h4>🏁 Fim de Jogo</h4>
        <p>Nível: {level}</p>
        <p>Pontuação: {score}</p>

        <button className={styles.button} onClick={restart}>
          Jogar Novamente
        </button>

        <button className={styles.buttonSecondary} onClick={goHome}>
          Voltar
        </button>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h3>👁️ Memória Visual</h3>

      <div className={styles.info}>
        <span>Nível: {level}</span>
        <span>Pontos: {score}</span>
      </div>

      <div
        className={styles.grid}
        style={{
          gridTemplateColumns: `repeat(${dimension}, 1fr)`
        }}
      >
        {Array.from({ length: gridSize }).map((_, i) => {
          const isPattern = pattern.includes(i);
          const isSelected = userInput.includes(i);

          return (
            <div
              key={i}
              onClick={() => toggleCell(i)}
              className={`${styles.cell}
                ${show && isPattern ? styles.pattern : ""}
                ${!show && isSelected ? styles.selected : ""}
                ${checking && isSelected && isPattern ? styles.correct : ""}
                ${checking && isSelected && !isPattern ? styles.wrong : ""}
              `}
            />
          );
        })}
      </div>

      {!show && pattern.length > 0 && (
        <button className={styles.button} onClick={check}>
          Confirmar
        </button>
      )}

      <p className={styles.feedback}>{feedback}</p>

      <div className={styles.actions}>
        {/* 🔥 BOTÃO SÓ ANTES DE COMEÇAR */}
        {pattern.length === 0 && (
          <button className={styles.button} onClick={start}>
            Iniciar Rodada
          </button>
        )}

        <button className={styles.buttonSecondary} onClick={goHome}>
          Voltar
        </button>
      </div>
    </div>
  );
};

export default VisualPattern;